
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(isWheelOrTire, badge, badgeIndex) {
                    return _createElement('span', {
                        'className': 'productitem__badge productitem__badge--soldout cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n                ', badge, '\n              ');
                }
                function repeatI2(isWheelOrTire, i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                function scopeProduct3(isWheelOrTire) {
                    var product = this.productData ?? this;
                    return [product.is_autosync_allowed ? _createElement('button', {
                            'className': 'cm_view-on-vehicle-btn productitem--action-trigger cm_button button-secondary',
                            'onClick': () => window.Convermax.openAutoSyncDialog(product.autosync_id, product.autosync_mpn, product.FitmentType?.includes('Tire')),
                            'type': 'button',
                            'key': '68851'
                        }, '\n    ', _translate(`view_product_on_vehicle`), '\n  ') : null];
                }
                function scopeIsWheelOrTire4() {
                    var isWheelOrTire = this.category && (this.category.includes('Wheels') || this.category.includes('Tires'));
                    return _createElement('li', {
                        'className': 'imagestyle--medium productgrid--item productitem--emphasis show-actions--mobile' + (this.on_sale ? ' productitem--sale' : ''),
                        'data-product-item': true,
                        'data-product-quickshop-url': this.url
                    }, _createElement('div', {
                        'className': 'productitem',
                        'data-product-item-content': true
                    }, _createElement('div', { 'className': 'productitem__container' }, _createElement('div', { 'className': 'productitem__image-container' }, _createElement('a', {
                        'className': 'productitem--image-link',
                        'href': this.url,
                        'data-product-page-link': true
                    }, _createElement('figure', {
                        'className': 'productitem--image',
                        'data-product-item-image': true
                    }, this.image2 ? _createElement('img', {
                        'className': 'productitem--image-alternate',
                        'src': this.resizeImage(this.image2),
                        'alt': this.removeHTML(this.title),
                        'onError': e => this.onImageError(e, 'image2'),
                        'key': '679'
                    }) : null, _createElement('img', {
                        'className': 'productitem--image-primary',
                        'alt': this.removeHTML(this.title),
                        'src': this.imageOrDefault(this.resizeImage(this.image)),
                        'onError': this.onImageError
                    }), _createElement.apply(this, [
                        'div',
                        { 'className': 'productitem__badge productitem__badge-container' },
                        this.out_of_stock ? _createElement('span', {
                            'className': 'productitem__badge productitem__badge--soldout',
                            'key': '1144'
                        }, '\n                ', _translate(`product_out_of_stock`), '\n              ') : null,
                        !this.out_of_stock && this.on_sale ? _createElement('span', {
                            'className': 'productitem__badge productitem__badge--sale',
                            'key': '1322'
                        }, _createElement('span', { 'data-badge-sales-range': true }, '\n                  Save\n                  ', _createElement('span', {
                            'className': 'money',
                            'data-price-money-saved': true
                        }, '\n                    ', this.formatPrice(this.compare_at_price - this.price), '\n                  '))) : null,
                        this._badges ? _map(this._badges, repeatBadge1.bind(this, isWheelOrTire)) : null
                    ])))), _createElement('div', { 'className': 'productitem--info' }, _createElement('div', { 'className': 'price productitem__price' }, _createElement('div', { 'className': 'price__compare-at' }, _createElement('span', { 'className': 'money price__compare-at--single' }, this.formatPrice(this.compare_at_price))), _createElement('div', { 'className': 'price__current price__current--emphasize' + (this.on_sale ? ' price__current--on-sale' : '') }, this.price_varies ? _createElement('span', { 'key': '2413' }, _translate(`price_from`), ' ') : null, _createElement('span', { 'className': 'money' }, this.formatPrice(this.min_price || this.price))), isWheelOrTire && !this.price_varies ? _createElement('div', {
                        'className': 'price__current--set',
                        'key': '2596'
                    }, '\n            ', _translate(`product_set_of`, {  count: 4  }), ': ', this.formatPrice(this.price * 4), '\n          ') : null), [this.review_count ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_review-stars',
                                'key': '28160'
                            },
                            _map([
                                0,
                                1,
                                2,
                                3,
                                4
                            ], repeatI2.bind(this, isWheelOrTire)),
                            _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                        ]) : null], _createElement('h2', { 'className': 'productitem--title' }, _createElement('a', Object.assign({}, {
                        'href': this.url,
                        'data-product-page-link': true
                    }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } }))), _createElement('span', { 'className': 'productitem--vendor' }, this.vendor && this.vendor_url ? _createElement('a', Object.assign({}, {
                        'href': this.vendor_url,
                        'key': '3504'
                    }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null), _createElement('div', { 'className': 'productitem__stock-level' }, _createElement('div', { 'className': 'product-stock-level-wrapper' }, this.inventory_quantity && !this.out_of_stock ? _createElement('span', {
                        'className': 'product-stock-level' + (this.inventory_quantity < 5 ? ' product-stock-level--low' : ' product-stock-level--high'),
                        'key': '3835'
                    }, _createElement('span', { 'className': 'product-stock-level__text' }, _createElement('div', { 'className': 'product-stock-level__badge-text' }, '\n                  ', this.inventory_quantity < 5 ? `Only ${ this.inventory_quantity } left!` : 'In stock', '\n                '))) : null, this.out_of_stock ? _createElement('span', {
                        'className': 'product-stock-level product-stock-level--none',
                        'key': '4360'
                    }, _createElement('span', { 'className': 'product-stock-level__text' }, _createElement('div', { 'className': 'product-stock-level__badge-text' }, _translate(`product_out_of_stock`)))) : null))), _createElement('div', {
                        'className': 'productitem--actions',
                        'data-product-actions': true
                    }, _createElement('div', { 'className': 'productitem--action quickshop-button' }, _createElement('button', {
                        'onClick': window.Convermax.quickView(this),
                        'className': 'productitem--action-trigger button-secondary mdc-ripple-surface mdc-ripple-upgraded',
                        'data-quickshop-full': true,
                        'type': 'button'
                    }, '\n            Quick shop\n          ')), _createElement('div', { 'className': 'productitem--action atc--button' }, this.variant_ids.length === 1 && !this.out_of_stock && (!this.ProductScope || this.ProductScope === 'child') ? _createElement('form', {
                        'method': 'post',
                        'action': '/cart/add',
                        'encType': 'multipart/form-data',
                        'key': '5133'
                    }, _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids
                    }), _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': isWheelOrTire ? 4 : 1
                    }), this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '5513'
                    }) : null, _createElement('button', {
                        'className': 'button-primary mdc-ripple-surface mdc-ripple-upgraded productitem--action-atc productitem--action-trigger',
                        'type': 'submit',
                        'aria-label': 'Add to cart'
                    }, _createElement('span', { 'className': 'atc-button--text' }, '\n                ', _translate(`product_add_to_cart`), isWheelOrTire ? ` ${ _translate(`product_set_of`, {  count: 4  }) }` : '', '\n              '))) : null, this.variant_ids.length > 1 && !this.out_of_stock || this.ProductScope === 'master' ? _createElement('a', {
                        'href': this.url,
                        'className': 'button-primary mdc-ripple-surface mdc-ripple-upgraded productitem--action-atc productitem--action-trigger',
                        'key': '6145'
                    }, _createElement('span', { 'className': 'atc-button--text' }, _translate(`product_select_options`))) : null, this.out_of_stock ? _createElement('button', {
                        'className': 'button-secondary mdc-ripple-surface mdc-ripple-upgraded productitem--action-atc productitem--action-trigger',
                        'aria-label': 'Out of stock',
                        'disabled': true,
                        'key': '6509'
                    }, _createElement('span', { 'className': 'atc-button--text' }, _translate(`product_out_of_stock`))) : null), _createElement('div', { 'className': 'productitem--action' }, [scopeProduct3.apply(this, [isWheelOrTire])])), this.price ? _createElement('p', {
                        'className': 'affirm-as-low-as',
                        'data-amount': this.price * 100,
                        'data-affirm-type': 'logo',
                        'data-affirm-color': 'blue',
                        'key': '7361'
                    }) : null)));
                }
                return scopeIsWheelOrTire4.apply(this, []);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'product-section--title product-recommendations--title cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'product-section--content product-row cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []